import { actions, reducer } from './reducer'
export { addMessageRecipients } from './reducer'

export const { removeAllMessageRecipients, removeMessageRecipient } = actions

export default reducer
